module.exports = __webpack_public_path__ + "static/media/poly-api.1d20a4e1.gif";